var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDeep(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 510,
    height: 510,
    viewBox: "257 252 510 510",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "glow",
    x: "-60%",
    y: "-60%",
    width: "220%",
    height: "220%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 11,
    result: "b"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "b"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rh",
    gradientUnits: "userSpaceOnUse",
    x1: 506,
    y1: 516,
    x2: 753,
    y2: 503
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0369A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0284C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lh",
    gradientUnits: "userSpaceOnUse",
    x1: 267,
    y1: 511,
    x2: 509,
    y2: 512
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1E3A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1D4ED8"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rh)",
    d: "M560.369 277.172C594.606 260.691 640.283 289.117 649.817 323.43C650.727 325.509 651.42 327.216 652.186 329.352C670.558 332.398 690.142 346.326 700.622 361.498C714.411 381.459 717.433 398.355 715.184 421.883C741.434 449.235 749.904 476.708 739.628 513.819C753.7 532.435 759.58 554.028 756.321 577.223C753.198 600.478 740.773 621.471 721.89 635.398C717.52 638.681 713.291 640.972 708.507 643.563C706.909 670.747 700.395 688.225 679.508 707.253C675.214 711.164 663.285 718.737 658.065 719.76C653.52 721.896 646.995 723.424 642.052 724.746C623.823 746.045 608.689 753.096 580.501 752.076C568.777 750.653 562.088 748.657 551.581 742.853C535.072 733.788 522.953 718.406 518 700.235C514.077 686.25 514.978 670.371 514.927 655.75L514.789 617.695L514.863 465.207L514.862 384.97C514.858 349.213 510.267 313.807 541.092 288.786C546.553 284.354 553.514 279.055 560.369 277.172Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M652.566 358.683C660.238 362.28 665.788 365.056 672.054 371.025C684.258 382.65 689.931 399.334 687.71 416.011C686.985 421.45 683.294 426.583 685.521 432.4C687.92 439.205 695.716 443.293 700.853 448.513C718.835 466.784 719.022 495.984 708.661 518.126C701.096 534.295 686.34 549.532 669.248 555.529C657.001 559.826 640.371 559.434 628.583 553.722C627.179 553.036 625.786 552.329 624.404 551.601C623.614 545.741 622.526 540.681 617.483 536.967C614.046 534.416 609.708 533.398 605.496 534.156C601.195 534.921 597.384 537.388 594.925 540.998C592.4 544.607 591.466 549.093 592.342 553.41C594.689 565.118 604.625 566.103 613.959 566.514C617.745 566.681 623.81 571.228 626.798 573.417C651.111 592.849 645.751 634.85 621.574 652.143C620.92 652.611 617.299 655.401 616.952 655.855C613.447 657.665 609.812 660.113 606.44 661.69C597.014 660.283 584.332 661.709 583.257 673.953C581.68 691.91 602.641 700.775 613.515 683.223C616.935 681.567 622.058 679.268 625.181 677.356C638.715 671.75 648.354 660.278 656.42 648.569C664.29 650.49 672.097 650.508 680.178 650.448C677.759 671.045 669.113 681.863 650.988 691.764C641.652 695.213 634.189 695.114 625.048 697.874C622.403 698.672 619.719 705.809 618.286 708.045C609.733 720.562 596.282 724.293 582.097 723.159C573.373 721.682 565.164 718.024 558.233 712.526C535.991 694.653 541.789 668.566 541.282 643.665C541.034 631.511 543.131 623.244 556.629 622.204L562.072 622.489C564.437 624.635 566.411 626.448 569.515 627.53C577.466 630.298 586.681 625.775 589.26 617.76C590.637 613.431 590.243 608.732 588.163 604.692C582.008 592.805 563.924 595.059 561.842 603.512C558.93 603.497 556.164 603.51 553.352 602.627C549.507 601.42 545.784 598.466 544.081 594.749C542.476 591.247 541.622 587.08 541.259 583.26C540.425 574.465 540.11 510.827 542.369 506.54C543.351 504.677 544.935 504.142 546.787 503.436C554.48 503.535 561.874 503.715 569.413 502.074C579.595 499.859 594.801 491.489 600.447 482.564L601.394 482.165C604.583 486.961 608.256 491.577 611.377 496.314C616.739 504.452 624.94 515.094 636.141 507.571C638.945 505.7 640.826 502.729 641.318 499.394C641.894 495.894 641.005 492.311 638.86 489.485C635.588 485.144 631.772 484.019 627.082 482.031C623.421 475.154 619.38 467.865 615.955 460.913C617.485 456.314 618.961 451.902 620.281 447.228C626.375 448.208 633.413 449.506 639.469 450.233C643.12 459.614 651.793 465.85 662.114 461.539C675.247 456.053 672.989 434.479 659.087 431.04C652.37 429.182 647.248 431.508 642.446 436.108C635.547 433.919 628.584 431.938 621.566 430.168C621.151 421.279 620.497 416.144 616.878 407.997C637.265 393.486 645.168 383.457 652.566 358.683Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M566.951 304.257C591.257 296.288 615.507 308.787 624.368 333.096C626.418 338.72 626.506 343.894 626.409 349.844C624.328 364.77 619.881 372.423 607.976 381.407C606.677 382.385 605.372 383.353 604.061 384.314C601.575 385.553 598.187 387.407 595.633 388.26C594.349 387.205 590.141 383.758 589.019 383.02C588.595 382.741 587.893 376.543 587.656 375.346C585.879 366.358 578.804 362.884 570.156 363.541C565.704 363.879 562.147 366.503 559.514 370.016C556.913 373.487 555.878 377.903 556.809 382.333C557.948 387.752 558.943 389.001 562.58 392.123C567.008 395.924 577.66 395.171 578.414 395.765C584.306 400.402 592.617 414.236 593.859 422.078C594.1 423.6 594.472 425.155 594.98 426.388C595.249 439.013 594.599 444.028 588.738 455.441C578.075 470.417 566.851 478.746 547.858 475.843C544.458 474.28 543.567 473.575 541.14 470.725C540.259 465.026 540.62 455.555 540.696 449.505C540.84 439.61 540.931 429.715 540.968 419.819L541.034 373.654C540.933 346.572 536.821 317.154 566.951 304.257Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M724.746 543.871C725.471 546.627 726.129 549.464 726.87 552.207C734.595 580.783 718.471 610.234 691.486 621.286C684.154 624.289 675.967 624.88 668.039 625.458L667.389 625.169C666.944 623.863 667.576 620.174 667.828 618.653C669.766 606.983 667.707 596.393 665.379 584.965C684.006 578.502 699.735 570.66 714.075 556.527C717.843 552.814 721.322 548.022 724.746 543.871Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lh)",
    d: "M425.397 274.572C433.005 273.105 439.827 272.15 447.495 273.209C479.474 277.626 502.56 302.656 507.699 333.985C509.295 343.711 509.109 352.151 509.19 361.944L509.385 393.075L509.489 506.505L509.528 626.101L509.489 661.973C509.479 669.013 509.724 678.393 508.987 685.235C507.682 697.66 503.342 709.574 496.35 719.928C479.385 744.601 447.166 759.017 417.832 749.717C402.874 745.134 391.395 737.033 382.522 723.987C363.182 719.858 349.636 714.411 336.027 699.231C322.453 684.278 315.386 664.54 316.383 644.37C310.97 640.953 305.014 637.814 299.88 633.938C285.231 622.877 274.162 605.319 269.778 587.517C265.235 569.072 266.675 547.073 274.933 529.83C277.775 523.895 281.594 519.162 284.902 513.654C282.225 499.808 280.64 491.759 282.028 477.085C284.002 456.207 294.213 435.348 310.566 421.961C305.414 377.208 330.01 339.171 374.189 328.343C381.914 301.163 398.245 283.157 425.397 274.572Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M401.042 551.317C385.752 560.286 371.337 561.946 354.619 555.262C314.45 539.203 293.714 481.416 325.141 447.822C330.141 442.477 338.356 439.034 340.485 431.543C341.803 426.601 339.033 420.556 338.314 415.62C337.164 405.952 339.019 396.17 342.571 387.259C348.5 372.385 359.365 364.376 373.776 358.379C373.842 358.771 373.908 359.163 373.975 359.555C378.112 379.557 390.106 397.061 407.267 408.139C404.148 415.718 403.526 420.379 403.337 428.553C397.109 431.347 393.029 432.649 386.423 434.358C376.994 427.928 364.636 427.664 359.251 439.19C357.164 443.626 356.988 448.724 358.764 453.294C362.387 462.667 371.834 466.277 381.078 462.252C386.743 459.785 389.153 454.376 391.073 448.875C394.576 448.514 399.844 447.641 403.183 448.29C404.993 448.641 405.084 449.517 405.844 450.945C408.125 452.737 409.667 461.483 407.691 464.969L406.871 466.993C407.678 468.171 407.954 468.066 409.358 468.581C411.846 472.635 404.169 476.032 407.357 480.399C411.019 485.414 405.82 494.575 407.246 498.085C410.735 497.555 409.263 495.273 412.855 495.116C416.605 491.846 420.055 486.521 422.338 482.104C434.882 494.874 447.924 503.391 466.322 503.628C470.105 503.677 474.729 503.355 478.373 503.529C480.199 504.831 483.076 506.725 483.2 509.071C483.75 519.447 483.243 531.434 483.224 541.748L483.326 569.961C483.399 587.888 484.255 604.246 460.92 603.422C451.349 591.284 433.105 596.42 432.236 611.06C431.979 615.47 433.469 619.804 436.384 623.124C444.148 631.816 453.871 628.173 461.59 621.932C467.678 621.903 472.504 621.578 477.07 626.363C483.285 632.876 483.683 640.912 483.496 649.366C483.286 658.844 483.583 668.255 483.4 677.755C483.156 690.445 477.272 702.603 467.968 711.146C458.191 719.991 445.809 723.771 432.66 723.217C419.661 721.077 411.276 716.559 404.731 705.072C403.084 702.181 400.055 698.562 397.165 696.845C393.86 694.883 388.271 695.494 384.534 694.812C377.122 693.458 368.913 689.324 363.116 684.667C352.783 676.304 346.235 664.149 344.934 650.92C353.925 651.339 358.932 650.847 367.772 649.284C379.186 664.754 391.182 676.533 410.292 682.433C412.508 686.918 414.687 689.688 419.628 691.467C424.137 693.064 429.101 692.769 433.389 690.648C442.558 686.1 444.246 676.132 439.283 667.716C434.024 658.8 424.649 663.162 417.922 660.947C405.781 656.951 394.707 646.613 388.749 635.367C381.84 622.428 380.454 607.245 384.906 593.269C389.471 578.982 399.02 571.91 411.861 565.241C416.484 566.157 419.683 566.787 424.248 564.651C427.856 562.929 430.612 559.819 431.889 556.031C433.362 551.76 432.986 546.685 430.857 542.696C429.022 539.195 425.834 536.599 422.034 535.512C409.063 531.764 403.834 540.626 401.042 551.317Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E3A8A",
    d: "M405.844 450.945C408.125 452.737 409.667 461.483 407.691 464.969L406.871 466.993C407.678 468.171 407.954 468.066 409.358 468.581C411.846 472.635 404.169 476.032 407.357 480.399C411.019 485.414 405.82 494.575 407.246 498.085C410.735 497.555 409.263 495.273 412.855 495.116C406.344 500.885 406.807 508.061 396.982 509.752C393.589 510.368 390.091 509.577 387.292 507.562C384.172 505.287 382.156 501.801 381.741 497.962C381.305 494.46 382.309 490.932 384.523 488.184C387.992 483.939 392.183 483.161 397.205 482.622C401.027 474.634 404.035 469.045 408.527 461.52C407.745 458.886 405.742 453.33 405.844 450.945Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M423.927 306.843C434.848 302.009 444.889 299.727 456.423 304.243C467.11 308.427 474.742 315.167 479.304 325.753C481.161 330.045 482.301 334.614 482.678 339.276C483.209 345.848 482.943 355.482 482.933 362.242L482.875 400.072C482.849 413.707 482.897 427.341 483.018 440.975C483.065 448.36 483.173 455.829 483.054 463.164C482.918 467.976 481.844 473.481 476.687 475.174C470.236 477.292 460.627 477.096 454.601 473.865C421.886 456.323 421.463 419.453 445.788 395.092C456.16 396.352 465.425 392.375 466.321 380.838C466.66 376.199 465.022 371.633 461.811 368.267C451.812 357.588 435.083 365.273 435 380.611C434.997 381.354 435 382.097 435.01 382.84C432.496 384.41 429.757 386.635 427.017 387.42C425.464 387.084 425.517 387.107 424.134 386.328C413.021 380.078 405.375 372.894 401.381 360.581C396.9 346.769 400.307 332.077 408.505 320.434C412.809 314.324 417.754 310.875 423.927 306.843Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M300.666 544.984C303.536 547.646 308.766 555.049 312.251 558.464C326.494 572.421 341.664 578.938 359.977 585.009C355.76 599.872 355.311 610.92 358.52 625.908C334.351 624.832 314.201 615.208 302.287 592.854C294.142 577.572 295.365 561.07 300.666 544.984Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "rgba(255,255,255,0.65)",
    strokeWidth: 8,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 512,
    y1: 305,
    x2: 390,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 512,
    y1: 305,
    x2: 632,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 390,
    y1: 320,
    x2: 302,
    y2: 490
  }), /*#__PURE__*/React.createElement("line", {
    x1: 632,
    y1: 320,
    x2: 718,
    y2: 490
  }), /*#__PURE__*/React.createElement("line", {
    x1: 302,
    y1: 490,
    x2: 392,
    y2: 658
  }), /*#__PURE__*/React.createElement("line", {
    x1: 718,
    y1: 490,
    x2: 630,
    y2: 658
  }), /*#__PURE__*/React.createElement("line", {
    x1: 512,
    y1: 305,
    x2: 512,
    y2: 508
  }), /*#__PURE__*/React.createElement("line", {
    x1: 390,
    y1: 320,
    x2: 512,
    y2: 508
  }), /*#__PURE__*/React.createElement("line", {
    x1: 632,
    y1: 320,
    x2: 512,
    y2: 508
  }), /*#__PURE__*/React.createElement("line", {
    x1: 302,
    y1: 490,
    x2: 512,
    y2: 508
  }), /*#__PURE__*/React.createElement("line", {
    x1: 718,
    y1: 490,
    x2: 512,
    y2: 508
  }), /*#__PURE__*/React.createElement("line", {
    x1: 392,
    y1: 658,
    x2: 512,
    y2: 508
  }), /*#__PURE__*/React.createElement("line", {
    x1: 630,
    y1: 658,
    x2: 512,
    y2: 508
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#glow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 305,
    r: 20,
    fill: "white",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 390,
    cy: 320,
    r: 20,
    fill: "white",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 632,
    cy: 320,
    r: 20,
    fill: "white",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302,
    cy: 490,
    r: 20,
    fill: "white",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 718,
    cy: 490,
    r: 20,
    fill: "white",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 392,
    cy: 658,
    r: 20,
    fill: "white",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 630,
    cy: 658,
    r: 20,
    fill: "white",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 508,
    r: 30,
    fill: "white",
    opacity: 0.96
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeep);
export default __webpack_public_path__ + "static/media/icon-deep.f35006381fd33495cf15cdc382e05b9c.svg";
export { ForwardRef as ReactComponent };